
(function(){
  if (window.__erDepartmentMenuBound) return;
  window.__erDepartmentMenuBound = true;
  function activate(tab){
    if (!tab || tab.getAttribute('aria-selected') === 'true') return;
    const menu = tab.closest('[data-er-dept-menu]');
    if (!menu) return;
    const id = tab.getAttribute('aria-controls');
    if (!id) return;
    const panel = document.getElementById(id);
    if (!panel || !menu.contains(panel)) return;
    menu.querySelectorAll('[data-er-dept-tab]').forEach(function(item){
      const selected = item === tab;
      item.setAttribute('aria-selected',selected?'true':'false');
      item.tabIndex = selected?0:-1;
    });
    menu.querySelectorAll('[data-er-dept-panel]').forEach(function(item){
      item.hidden = item !== panel;
    });
    const area=menu.querySelector('.er-dept-mega__panel-area');
    if(area) area.scrollTop=0;
  }
  document.addEventListener('pointerover',function(event){
    if(event.pointerType==='touch')return;
    const tab=event.target.closest&&event.target.closest('[data-er-dept-tab]');
    if(tab)activate(tab);
  });
  document.addEventListener('click',function(event){
    const tab=event.target.closest&&event.target.closest('[data-er-dept-tab]');
    if(tab)activate(tab);
  });
  document.addEventListener('focusin',function(event){
    const tab=event.target.closest&&event.target.closest('[data-er-dept-tab]');
    if(tab)activate(tab);
  });
  document.addEventListener('keydown',function(event){
    const tab=event.target.closest&&event.target.closest('[data-er-dept-tab]');
    if(!tab)return;
    const menu=tab.closest('[data-er-dept-menu]');
    if(!menu)return;
    const tabs=Array.from(menu.querySelectorAll('[data-er-dept-tab]'));
    const index=tabs.indexOf(tab);
    let next=-1;
    if(event.key==='ArrowDown' || event.key==='ArrowRight')next=(index+1)%tabs.length;
    if(event.key==='ArrowUp' || event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
    if(event.key==='Home')next=0;
    if(event.key==='End')next=tabs.length-1;
    if(next>=0){event.preventDefault();tabs[next].focus();activate(tabs[next]);}
  });
})();
